// extracted by mini-css-extract-plugin
export default {"bar":"SendMessageBar_bar__YTEVo"};